export const API_ROOT_DEV = 'http://10.10.3.64:8080'           // 测试环境的接口地址
export const ENV_ROOT_DEV = 'http://106.14.29.228:8080/'							// 运行环境

//export const API_ROOT_PRO = 'http://bosstest.fanqiebianli.com/api/' // 线上环境




// WEBPACK FOOTER //
// ./src/config/env.js